import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import CommandoToday from "@/components/CommandoToday";
import CommandoBusiness from "@/components/CommandoBusiness";
import { SuiviApporteur, SuiviApporteurDossier, SuiviClient, DossiersAReprendre } from "@/components/CommandoBlocks";
import { PrioriteCard } from "@/components/commando/PrioriteCard";
import { api, formatEURCompact } from "@/lib/api";
import { toast } from "sonner";

const fr = (iso) => new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });

// V11 — Vue secondaire : toutes les recommandations (file complète V11, reportées, historique) + les 10 blocs historiques réutilisés tels quels
export default function CommandoRecommandations() {
  const [data, setData] = useState(null);
  const [key, setKey] = useState(0);
  const load = async () => { try { setData((await api.get("/commando/v11")).data); } catch { toast.error("Recommandations indisponibles"); } };
  useEffect(() => { load(); }, [key]);
  const refresh = () => setKey((k) => k + 1);
  const cancelReport = async (id) => { try { await api.delete(`/commando/business/report/${encodeURIComponent(id)}`); toast.success("Report annulé"); refresh(); } catch { toast.error("Action refusée"); } };
  const undo = async (id) => { try { await api.post("/commando/v11/actions/undo", { action_id: id }); toast.success("Action rouverte"); refresh(); } catch { toast.error("Action refusée"); } };
  return (
    <Layout title="Toutes les recommandations" subtitle={<Link to="/" className="underline" data-testid="c11-back">← Retour au Commando</Link>}>
      <div className="space-y-6" data-testid="commando-recommandations">
        {data && (
          <>
            <section data-testid="c11-all-queue">
              <h2 className="text-base font-semibold text-slate-900 mb-2">File complète des recommandations ({data.toutes.length})</h2>
              <div className="space-y-2">{data.toutes.map((p, i) => <PrioriteCard key={p.action_id} p={p} index={i} onChanged={refresh} />)}</div>
              {data.toutes.length === 0 && <div className="card-base p-4 text-sm text-slate-500">Aucune recommandation active.</div>}
            </section>
            <section className="card-base p-4" data-testid="c11-reportees">
              <h2 className="text-base font-semibold text-slate-900 mb-2">Actions reportées ({data.reportees.length})</h2>
              {data.reportees.length === 0 && <div className="text-sm text-slate-500">Aucune action reportée.</div>}
              {data.reportees.map((r) => (
                <div key={r.action_id} className="flex items-center gap-2 text-sm py-1.5 border-b border-slate-100 last:border-0" data-testid={`c11-reportee-${r.action_id}`}>
                  <span className="flex-1 min-w-0"><b>{r.nom}</b> — {r.action} <span className="text-slate-500">· reportée au {fr(r.reported_until)}</span></span>
                  <button onClick={() => cancelReport(r.action_id)} className="text-xs font-medium underline" data-testid="c11-report-cancel">Annuler le report</button>
                </div>
              ))}
            </section>
            <section className="card-base p-4" data-testid="c11-historique">
              <h2 className="text-base font-semibold text-slate-900 mb-2">Historique des actions effectuées ({data.historique.length})</h2>
              {data.historique.length === 0 && <div className="text-sm text-slate-500">Aucune action effectuée pour l'instant.</div>}
              {data.historique.map((h) => (
                <div key={h.action_id + h.done_at} className="flex items-center gap-2 text-sm py-1.5 border-b border-slate-100 last:border-0" data-testid="c11-hist-item">
                  <span className="text-xs text-slate-400 tabular-nums w-14">{fr(h.done_at)}</span>
                  <span className="flex-1 min-w-0"><b>{h.nom}</b> — {h.action} <span className="text-slate-400">· {formatEURCompact(h.ca_net)}</span></span>
                  <Link to={`/dossier/${h.dossier_id}`} className="text-xs underline">Dossier</Link>
                  <button onClick={() => undo(h.action_id)} className="text-xs text-slate-500 underline" data-testid="c11-hist-undo">Rouvrir</button>
                </div>
              ))}
              <p className="text-[11px] text-slate-400 mt-2">{data.notes.join(" ")}</p>
            </section>
          </>
        )}
        <h2 className="text-base font-semibold text-slate-900 pt-2">Modules historiques</h2>
        <CommandoBusiness refreshKey={key} />
        <CommandoToday refreshKey={key} />
        <DossiersAReprendre refreshKey={key} />
        <SuiviApporteurDossier refreshKey={key} />
        <SuiviApporteur refreshKey={key} />
        <SuiviClient refreshKey={key} />
      </div>
    </Layout>
  );
}
